<template src="./index.html">
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import { jump } from '../../util/jumpPage'

export default {
  name: 'claimDialog',

  props: {
    visible: Boolean
  },

  data () {
    return {
      agree: false,
    }
  },

  computed: {
		...mapState('dataCertificate', {
      certificate: s => s.certificate && s.certificate.info || {}
		}),
    baseImgSrc () {
      return BASE_IMG_MAP[parseInt(this.certificate.secLevel)]
    }
  },

  methods: {
    closeDialog () {
      if (!this.agree) {
        return
      }

      this.$emit('close')
    },
    go_page (page) {
      jump(this, {
        page,
        deep:true
      })
    },
  },

}
</script>

<style scoped src="./index.less" lang="less">
</style>
